module.exports = __webpack_public_path__ + "img/ts17.9f94d334.png";